import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table } from "antd";
import Card from "components/card";
import PopupButton from "components/button/PopupButton";
import CrudOption from "components/dropdown/crudoption";
import PurchaseOrderForm from "./PurchaseOrderForm";
import { handleTableChange } from "../../../../utils";
import { MODULE_PURCHASE_ORDER } from "variables/constants";
import {
	getPurchaseOrderList,
	doPurchaseOrderDelete,
	doPurchaseOrderReset,
} from "../../../../redux/purchaseorder/purchaseOrderState";

const PurchaseOrderTable = ({
	recordList,
	pagination,
	filters,
	doSearch,
	doDelete,
	doRecordReset,
}) => {

	const currencySymbols = {
		PHP: "₱",
		USD: "$",
		EUR: "€",
	};

	const columns = [
		{
			title: "PO Number",
			dataIndex: "por_number",
			key: "por_number",
			width: "15%",
			render: (por_number) => <span>{por_number}</span>,
		},
		{
			title: "Vendor",
			dataIndex: "vendor_name",
			key: "vendor_name",
			width: "20%",
			render: (vendor_name) => <span>{vendor_name}</span>,
		},
		{
			title: (
				<>
					<div>Purchase Date /</div>
					<div>Acquired Date</div>
				</>
			),
			key: "purchase_info",
			width: "15%",
			render: (_, record) => (
				<>
					<div>{record?.por_purchase_date || "-"}</div>
					<div>{record?.por_acquired_date || "-"}</div>
				</>
			),

		},
		{
			title: "Status",
			dataIndex: "approval_status_name",
			key: "approval_status_name",
			width: "12%",
			render: (approval_status_name) => <span>{approval_status_name}</span>,
		},
		{
			title: "Delivery Status",
			dataIndex: "delivery_status_name",
			key: "delivery_status_name",
			width: "12%",
			render: (delivery_status_name) => <span>{delivery_status_name}</span>,
		},
		{
			title: "Payment Status",
			dataIndex: "payment_status_name",
			key: "payment_status_name",
			width: "12%",
			render: (payment_status_name) => <span>{payment_status_name}</span>,
		},
		{
			title: "Total Items",
			dataIndex: "payment_status_name",
			key: "payment_status_name",
			width: "12%",
			render: (payment_status_name) => <span> - </span>,
		},
		{
			title: "Total Amount",
			dataIndex: "por_total_amount",
			key: "por_total_amount",
			width: "15%",
			render: (amount, record) => (
				<span>
					{currencySymbols[record.por_currency] || "₱"}
					{Number(amount || 0).toLocaleString(undefined, {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					})}
				</span>
			),
		},
		{
			title: (
				<PopupButton id="add_purchase_order" title="Add Purchase Order" label="Add" btnClass="btn-small" modalWidth={1200} moduleId={0}>
					<PurchaseOrderForm recordId={0} mode="edit" />
				</PopupButton>
			),
			dataIndex: "por_id",
			key: "por_id",
			width: "12%",
			render: (_, record) => {
				const isDraft =
					record.approval_status_name === "Draft";

				return (
					<CrudOption
						recordId={record.por_id}
						baseRoute="/console/purchase-orders"
						allowView={!isDraft}
						allowEdit={isDraft}
						allowDelete={true}
						deleteHandler={doDelete}
						viewHandler={(recordId) => (
							<PurchaseOrderForm
								recordId={recordId}
								mode="view"
							/>
						)}
						title="Edit Purchase Order"
						editHandler={(recordId) => (
							<PurchaseOrderForm
								recordId={recordId}
								mode="edit"
							/>
						)}
						closeHandler={doRecordReset}
					/>
				);
			}
		},
	];

	useEffect(() => {
		doSearch({
			paginate: pagination.per_page,
		});
	}, [doSearch, pagination.per_page]);

	return (
		<Card extra={"w-full h-full p-4"}>
			<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
				<Table
					dataSource={recordList}
					columns={columns}
					rowKey={(record) => record.por_id}
					pagination={{
						...pagination,
						showTotal: (total, range) =>
							`${range[0]} - ${range[1]} of ${total} records`,
					}}
					onChange={handleTableChange(doSearch, filters)}
				/>
			</div>
		</Card>
	);
};

const mapStateToProps = (state) => ({
	recordList: state.purchaseOrder.purchaseOrderList?.items,
	pagination: state.purchaseOrder.purchaseOrderList?.pagination,
	filters: state.purchaseOrder.purchaseOrderList?.filters,
	requesting: state.purchaseOrder.purchaseOrderList?.requesting,
	error: state.purchaseOrder.purchaseOrderList?.error,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getPurchaseOrderList(filters)),
	doDelete: (recordId) => dispatch(doPurchaseOrderDelete(recordId)),
	doRecordReset: () => dispatch(doPurchaseOrderReset()),
});

export default connect( mapStateToProps, mapDispatchToProps )(PurchaseOrderTable);